import { ButtonBase, Theme } from '@mui/material'
import makeStyles from '@mui/styles/makeStyles'
import clsx from 'clsx'
import { percent } from 'csx'
import { observer } from 'mobx-react'
import React, { useEffect, useState } from 'react'
import { FullscreenSpinner } from '../../components/feedback/circular'
import { IDocumentRenderer, OcrImageData } from './IDocumentRenderer'
import { useOcrContext } from './OcrContext'

export const PageDisplaySidebar = observer(() => {
	const styles = useStyles()
	const context = useOcrContext()

	const [documentRenderer, setDocumentRenderer] = useState<
		IDocumentRenderer | undefined
	>(context.controller.documentRenderer)

	useEffect(() => {
		setDocumentRenderer(context.controller.documentRenderer)
	}, [context.controller, context.controller.documentRenderer])

	return (
		<>
			{documentRenderer ? (
				<div className={styles.sidebar}>
					{[...Array(documentRenderer.pageCount).keys()].map(
						(pageNumber, i) => {
							return (
								<ButtonBase
									key={i}
									onClick={() =>
										context.controller.mapControl.fitToPage?.call(
											null,
											pageNumber,
										)
									}
								>
									<PageViewer
										pageNumber={pageNumber}
										documentRenderer={documentRenderer}
										key={i}
										className={
											context.controller.currentPageNumber == pageNumber
												? clsx(styles.sidebarCanvas, styles.selectedPage)
												: styles.sidebarCanvas
										}
									/>
								</ButtonBase>
							)
						},
					)}
				</div>
			) : (
				<FullscreenSpinner />
			)}
		</>
	)
})

type PageViewerProps = {
	pageNumber: number
	documentRenderer: IDocumentRenderer
	className?: string
}

const PageViewer: React.FC<PageViewerProps> = observer(
	(props: PageViewerProps) => {
		const [imageData, setImageData] = useState<OcrImageData | undefined>(
			props.documentRenderer.getPage(props.pageNumber),
		)

		useEffect(() => {
			setImageData(props.documentRenderer.getPage(props.pageNumber))
		}, [props.documentRenderer, props.documentRenderer.pageCount])

		if (imageData === undefined || !imageData.rendered)
			return <FullscreenSpinner />

		return (
			<div>
				<img src={imageData.dataUrl} className={props.className}></img>
			</div>
		)
	},
)

const useStyles = makeStyles((theme: Theme) => ({
	sidebar: {
		backgroundColor: theme.palette.background.paper,
		overflowY: 'auto',
		display: 'flex',
		flexDirection: 'column',
		alignItems: 'center',
		flex: 2,
	},

	sidebarCanvas: {
		padding: theme.spacing(3),
		width: percent(100),
	},

	selectedPage: {
		background:
			theme.palette.mode === 'dark'
				? theme.palette.grey[700]
				: theme.palette.grey[300],
	},
}))
